import { render, staticRenderFns } from "./VaPopover.vue?vue&type=template&id=1ad3cc03&"
import script from "./VaPopover.vue?vue&type=script&lang=js&"
export * from "./VaPopover.vue?vue&type=script&lang=js&"
import style0 from "./VaPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports